/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { HowItWorksWrapper  } from './styles'
import { Header2, Text } from '../../styles/Components'

const WhatWereLookingFor = () => {
  const data = {
    'Authentic advocacy': 'We work with people who truly love Glamsquad and want to share it with their community.',
    'Strong engagement': 'You have a deep connection with your digital audience—and it shows.',
    'All niches': 'Not a beauty creator? No problem. We work with people across a range of topics and interests.'
  }
  return (
    <HowItWorksWrapper>
      <div className='how-content'>
        <Header2 align='center' >What we’re looking for</Header2>
        <div className='items-container'>
          { Object.keys(data).map((item, i) => (
            <div className='item' key={i}>
              <Text weight={700} fontSize={22}>
                {item}
              </Text>
              <Text weight={400} fontSize={22}>
                {data[item]}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </HowItWorksWrapper>
  )
}

export default WhatWereLookingFor 
